module.exports = __webpack_public_path__ + "img/yourStory.94e3683.jpg";